const INTERVIEW = {
  STATUSES: [
    { caption: 'Назначено', value: 'appointed' },
    { caption: 'Назначен на смену', value: 'assignedToOrder' },
    { caption: 'Явка', value: 'success' },
    { caption: 'Не пришёл', value: 'failed' },
    { caption: 'Активна', value: 'active' },
  ],
  CAUSE: [
    { caption: 'Недоофрормленный исполнитель', value: 'under_formed' },
    { caption: 'Закрылась заявка, не успели, остался в штате', value: 'closed' },
    { caption: 'Нашел другую работу сопоставил работу и зп, не на это рассчитывал', value: 'found_job' },
    { caption: 'Не верная информация (график, обещали подработки а тут график)', value: 'disinformation' },
    { caption: 'Заболел', value: 'got_sick' },
    { caption: 'Не готов делать ЛМК, Ковид', value: 'lmk' },
    { caption: 'Отказ администрации по разным причинам', value: 'refusal_administration' },
    { caption: 'Неадекватный', value: 'inadequate' },
    { caption: 'Не нравиться вывод денег исполнитель', value: 'withdrawal_money' },
    { caption: 'Не понимает приложение', value: 'bad_application' },
    { caption: 'Телефон с кнопками', value: 'telephone' },
    { caption: 'Не своевременная обработка исполнителя координатором', value: 'bad_coordinator_work' },
    { caption: 'Не смог подобрать точку', value: 'bad_points' },
    { caption: 'Далеко', value: 'far' },
    { caption: 'Не дозвонились', value: 'ignores' },
    { caption: 'Не понравился магазин\\администрация', value: 'bad_administration' },
  ],
};

module.exports = {
  STATUS: Object.values(INTERVIEW.STATUSES).reduce((acc, cur) => {
    acc[cur.value.toLocaleUpperCase()] = cur.value;
    return acc;
  }, {}),
  CAUSE: INTERVIEW.CAUSE,
  STATUSES: INTERVIEW.STATUSES,
};
